<template>
  <div class="sample-page">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>患者管理</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="page-handle">
      <div class="left">
        <a-button v-auth="'10101'" @click="goMoreEdit" type="primary">批量患者编辑</a-button>
        <a-button v-auth="'10107'" @click="goGrouping" type="primary">患者入组</a-button>
        <a-button v-auth="'10109'" @click="exportExcelClick" type="primary">导出列表</a-button>
        <!--<a-button v-auth="'10102'" @click="goTerieval()">入组</a-button>-->
        <!--<a-button v-auth="'10103'" @click="getNoTerieval()">不入组</a-button>-->
      </div>
      <div class="right">
        <a-input-search v-model='orConditionStr' placeholder="请输入姓名/身份证/数据库ID" style="width: 320px;font-size:12px"
          @search="onSearch" />
        <a-tooltip placement="bottomRight">
          <template slot="title">
            患者的出生日期、疾病类型、患者组未在规定时间内录入
          </template>
          <a-checkable-tag class="cktag-warnig" v-model="warning" button-style="solid" @change="ckWarning">提醒
          </a-checkable-tag>
        </a-tooltip>
        <a class="filter-btn" @click="drawerVisible = true">筛选
          <a-icon type="filter" />
        </a>
        <a-drawer title="筛选" :width="600" placement="right" :closable="false" :visible="drawerVisible" @close="onClose"
          :body-style="{ paddingBottom: '80px' }">
          <div class="filter-drawer-content">
            <div class="filter-drawer-title">患者组
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="8">
                <a-button :type="!patientGroupId ? 'primary' : 'default'" @click="handleGroupClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="8" v-for="item in dataGroup" :key="item.id">
                <a-button :type="patientGroupId == item.id ? 'primary' : 'default'"
                  @click="handleGroupClick({ key: item.id })">
                  {{ item.groupName }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">疾病类型
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!diseaseType ? 'primary' : 'default'" @click="handleClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in diseaseData.data" :key="item.keyId">
                <a-button :type="diseaseType === item.keyId ? 'primary' : 'default'"
                  @click="handleClick({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">就诊医院
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="12">
                <a-button :type="!findDeptId ? 'primary' : 'default'" @click="checkHospital({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="12" v-for="item in hospitalData" :key="item.keyId">
                <a-button :type="findDeptId == item.keyId ? 'primary' : 'default'"
                  @click="checkHospital({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
          </div>
          <div :style="{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }">
            <a-button style="marginRight: 8px" @click="resetDrawer">
              重置
            </a-button>
            <a-button type="primary" @click="okDrawer">
              确定
            </a-button>
          </div>
        </a-drawer>
      </div>
    </div>
    <div class="page-content">
      <a-table class="hospital-table" :pagination="false" :rowSelection="rowSelection" :columns="columns"
        :dataSource="data" :loading="loading" @change="handleTableChange" :rowKey="record => record.id" size="middle">
        <template slot="warningStatus" slot-scope="text,record">
          <a-tag v-if="record.warningHours !== 0" :color="record.warningStatus === '临近' ? 'orange' : '#f50'">
            {{ record.warningStatus }}
          </a-tag>
          <a-tag v-else color="#87d068">正常</a-tag>
        </template>
        <router-link v-auth="'10105'" slot="patientName" slot-scope="text,record"
          :to="{ path: '/sufferer/detail', query: { id: record.id } }">{{ text }}</router-link>
        <div slot='patientCardNo' slot-scope="text,record" style="word-break: break-all;">{{ record.patientCardNo
          | formatidcard }}
        </div>
        <div slot-scope="text,record" class="table-tr-handle" slot="msgFrom">
          <span class="handle-btn" v-auth="'10104'" @click='edit($event, record)'>编辑</span>
          <span class="handle-line" v-if="record.mergeFlag == 1">|</span>
          <span class="handle-btn" v-auth="'10108'" v-if="record.mergeFlag == 1"
            @click='merge($event, record)'>合并患者</span>
          <!-- <span class="handle-line">|</span>
					<span @click="deleteDiagnosis(record)" class="handle-btn">删除</span> -->
        </div>
        <template slot-scope="text,record" slot="address">
          <span v-if='record.province'>
            <span v-if='record.city'>
              <span v-if='record.country'>{{ record.provinceName + '/' + record.cityName + '/' + record.countryName
              }}</span>
              <span v-else>{{ record.provinceName + '/' + record.cityName }}</span>
            </span>
            <span v-else>{{ record.provinceName }}</span>
          </span>
          <span v-else>-</span>
        </template>
      </a-table>
      <div class="pagination">
        <a-pagination @change="pageChange" :pageSize.sync="pageSize" v-model="page" size="small" :total="resData.total" />
      </div>
    </div>
    <!-- 不如组的model -->
    <!-- <a-modal
		wrapClassName='lo-model'
		v-model="visible"
		@ok="handleOk"
	  >
		<p>Some contents...
	   <i class=" iconfont icon-jiagou"></i>
		</p>
		<p>Some contents...</p>
		<p>Some contents...</p>
	  </a-modal> -->
    <!-- end -->
    <!-- 不如组的弹窗 -->
    <page-model @close="closeModel" :visible="visible">
      <div class="in-group" v-if='visible && isShowGroup == 1'>
        <div class="model-content">
          <div class="title">
            患者管理_入组
          </div>
          <div class="model-type" v-show='selectArr.length == 0'>
            <span>请至少选择一个入组信息</span>
            <span>请至少选择一个入组信息</span>
          </div>
          <div class="model-type" v-show='isSelectNum == 2'>
            <span>患者信息不完善</span>
            <span>请确认信息完整</span>
          </div>
          <div class="model-type" v-show='isSelectNum == 3'>
            <span>确认要进入协作组吗</span>
            <span>确认后不可更改</span>
          </div>
          <div class="btn-group">
            <a-button type="primary" @click="ruzu()">确定</a-button>
            <a-button @click="closeModel()">取消</a-button>
          </div>
        </div>
      </div>
      <div class="no-group" v-if='visible && isShowGroup == 2'>
        <div class="model-content">
          <div class="title">
            患者管理_不入组
          </div>
          <div class="model-textarea">
            <textarea v-model='nogroupReason' name="test" id="model-area" cols="30" rows="10"
              placeholder="请输入不入组原因......如就诊日期、门诊号为空">
                      </textarea>
          </div>
          <div class="btn-group">
            <a-button type="primary" @click="noIngroup()">确定</a-button>
            <a-button @click="closeModel()">取消</a-button>
          </div>
        </div>
      </div>
      <!-- 组件批量编辑 -->
      <more-edit v-if='visible && isShowGroup == 3' :dataList='selectArr' @getData='update'
        @close='closeModel'></more-edit>
      <!-- end -->
      <!-- 组件页面编辑 -->
      <edit v-if='visible && isShowGroup == 4' :list='recordList' @getData='update' @close='closeModel'></edit>
      <!-- 合并患者-->
      <merge v-if='visible && isShowGroup == 5' :recordMerge='recordMerge' @getData='update' @close='closeModel'></merge>
      <!-- 患者入组 -->
      <go-grouping v-if='visible && isShowGroup == 6' :dataList='selectArr' @getData='update'
        @close='closeModel'></go-grouping>
      <!-- <end> -->
      <!-- <retrieval v-if="visible" :list="selectRows" ></retrieval> -->
    </page-model>
    <!-- end -->
  </div>
</template>

<script>
// import Dialog from '@/components/common/dialog'
import MoreEdit from './moreEdit'
import Edit from "./edit";
import GoGrouping from "./goGrouping";
import Merge from "./merge";
import { format } from 'path';
import auth from "../../directives/auth-utils";

const columns = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    title: "提醒",
    dataIndex: "warningStatus",
    scopedSlots: { customRender: "warningStatus" }
  },
  {
    title: "患者姓名",
    dataIndex: "patientName",
    scopedSlots: { customRender: "patientName" },
  },
  {
    title: "性别",
    scopedSlots: { customRender: "sexName" },
    dataIndex: "sexName",
    customRender: (text, record, index) => {
      if (!record.sexName) {
        return '-'
      } else {
        return record.sexName
      }
    }
  },
  {
    title: "初诊医院",
    dataIndex: "initialDeptsName",
    customRender: (text, record, index) => {
      if (!record.initialDeptsName) {
        return '-'
      } else {
        return record.initialDeptsName
      }
    }
  },
  {
    title: "数据库ID",
    dataIndex: "clinicalDbId",
    width: "10%",
    customRender: (text, record, index) => {
      if (!record.clinicalDbId) {
        return '-'
      } else {
        return record.clinicalDbId
      }
    }
  },
  {
    title: "出生日期",
    dataIndex: "ageBirthDay",
    customRender: (text, record, index) => {
      if (!record.ageBirthDay) {
        return '-'
      } else {
        return record.ageBirthDay
      }
    }
  },
  // {
  //   title: "籍贯",
  //   scopedSlots: {customRender: "address"},
  //   width: '12%',
  // },
  {
    title: "分组",
    width: '8%',
    customRender: (text, record, index) => {
      if (record.groupName) {
        return record.groupName;
      } else {
        return '-';
      }
    }
  },
  {
    title: "疾病类型",
    dataIndex: "diseaseType",
    customRender: (text, record, index) => {
      if (!record.diseaseType) {
        return '-'
      } else {
        return record.diseaseType
      }
    }
  },
  {
    title: "录入时间",
    dataIndex: "createTime",
    sorter: true,
    customRender: (text, record, index) => {
      if (!record.createTime) {
        return '-'
      } else {
        return record.createTime
      }
    },
    width: '12%'
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    sorter: true,
    customRender: (text, record, index) => {
      if (!record.updateTime) {
        return '-'
      } else {
        return record.updateTime
      }
    },
    width: '12%'
  },
  {
    title: "操作",
    width: '10%',
    scopedSlots: { customRender: "msgFrom" }
  }
];

export default {
  data() {
    return {
      data: [],
      columns,
      visible: false,
      loading: false,
      page: 1,
      pageSize: 10,
      resData: '',
      inGroup: {
        title: '是否入组',
        data: [
          {
            key: 0,
            value: '待入组'
          },
          {
            key: 1,
            value: '是'
          }, {
            key: 2,
            value: '否'
          }, {
            key: 'default',
            value: '全部'
          },]

      },
      dataGroup: [],
      groupTitle: '选择组',
      diseaseData: {
        title: '疾病类型',
        data: []
      },
      orConditionStr: "",
      pageSize: 10,
      pageNum: 1,
      isInGroup: '',//是否入组
      patientGroupId: '', // 分组
      diseaseType: '',//疾病类型
      findDeptId: '',//就诊医院
      warning: false, //提醒
      selectIds: [],
      selectArr: [],
      isSelectNum: 1,//入组显示信息
      isShowGroup: 1,// 1 入组 2  入组
      nogroupReason: '',//原因
      recordList: '', //
      visible: false,
      selectedRowKeys: [],
      recordMerge: {},
      sortOrder: '',
      sortField: '',
      hospitalName: "就诊医院",
      hospitalData: [],
      drawerVisible: false
    };
  },
  filters: {
    formatidcard(value) {
      // 15位身份证举例：130503 670401 001的含义; 13为河北，05为邢台，03为桥西区，出 生日期为1967年4月1日，顺序号为001。
      if (value) {
        if (value.length == 15) {
          return value.replace(/(\d{6})\d{7}(\w{2})/, "$1******$2");
        } else if (value.length == 18) {
          return value.replace(/(\d{6})\d{10}(\w{2})/, "$1******$2");
        } else {
          return value
        }
      } else {
        return '-'
      }

    }
  },
  components: { MoreEdit, Edit, Merge, GoGrouping },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectArr = []
          this.selectedRowKeys = selectedRowKeys
          this.selectArr = JSON.parse(JSON.stringify(selectedRows))
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  },
  mounted() {
    this.getGroupList();
    this.gethospital();
    this.getStorage();
    this.getDiseaseTypeFilterStat();
  },
  methods: {
    // 首次加载时获取缓存的列表筛选值
    getStorage() {
      if (localStorage.getItem('SUFFER_FILTER')) {
        const params = JSON.parse(localStorage.getItem('SUFFER_FILTER'));
        this.pageSize = params.pageSize;
        this.pageNum = params.pageNum;
        this.orConditionStr = params.orConditionStr;
        this.isInGroup = params.isInGroup;
        this.patientGroupId = params.patientGroupId;
        this.diseaseType = params.diseaseType;
        this.findDeptId = params.findDeptId;
        this.warning = params.warning;
        if (params.diseaseType) {
          this.diseaseData.data.forEach(item => {
            if (item.value == params.diseaseType) {
              this.handleClick({ key: item.keyId });
            }
          })
        }
      }
      this.getSearchData()
      // } else {
      //   this.getData();
      // }
    },
    onClose() {
      this.drawerVisible = false;
    },
    resetDrawer() {
      this.pageNum = 1;
      this.page = 1;
      this.patientGroupId = '';
      this.diseaseType = '';
      this.findDeptId = '';
      this.getSearchData();
    },
    okDrawer() {
      this.pageNum = 1;
      this.page = 1;
      this.drawerVisible = false;
      this.getSearchData();
    },
    // 就诊医院列表
    gethospital() {
      this.$get("report/report/findDeptStatList", { module: 1 }).then(res => {
        this.hospitalData = res.data.data;
        this.checkHospital({ key: this.findDeptId });
      });
    },
    checkHospital(event) {
      if (event.key == 'default') {
        this.findDeptId = '';
        this.hospitalName = '就诊医院';
      } else {
        this.hospitalData.forEach(item => {
          if (item.keyId == event.key) {
            this.hospitalName = item.value;
            return;
          }
        })
        this.findDeptId = event.key;
      }
    },
    handleTableChange(pagination, filters, sorter) {
      this.sortOrder = sorter.order;
      this.sortField = sorter.columnKey;
      this.getSearchData();
    },
    // 组列表
    getGroupList() {
      this.dataGroup = [];
      const self = this;
      self.$get("patientgroup", { module: 1 }).then(res => {
        self.dataGroup = res.data.data;
        if (self.patientGroupId) {
          self.handleGroupClick({ key: self.patientGroupId });
        }
      });
    },
    getDiseaseTypeFilterStat() {
      this.diseaseData.data = [];
      const self = this;
      self.$get("patient/getDiseaseTypeFilterStat", { module: 1 }).then(res => {
        self.diseaseData.data = res.data.data;
        if (self.diseaseType) {
          self.handleClick({ key: self.diseaseType });
        }
      });
    },
    //  判断是否入组
    // GET /api/patient/assertCanInGroup
    assertCanInGroup(ids) {
      this.$get('/patient/assertCanInGroup', {
        ids: ids
      }).then(res => {
        if (res.data.code == 1) {
          this.visible = true;
          this.isSelectNum = 3
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    goTerieval() {
      let flag = false
      this.selectIds = []
      if (this.selectArr.length > 0) {
        this.isShowGroup = 1
        for (let val of this.selectArr) {
          if (val.isInGroup == 1) {
            flag = true
            this.$message.error('请选择状态为不入组或待入组的数据')
            break;
          } else {
            flag = false
          }
        }
        if (!flag) {
          for (let val of this.selectArr) {
            // if(val.hosBarCode==null||val.patientName==null||val.barCode==null||val.ageBirthDay==null||val.diseaseType==null){
            //   //  this.isSelectNum = 2
            //   this.visible = false;
            //   this.$message.error('患者信息不完善,请确认信息完整')
            //   break;
            // }
            this.selectIds.push(val.id)

          }
          this.assertCanInGroup(this.selectIds)
        }
      } else {
        this.$message.error('请选择至少选择一条数据')
      }
    },
    getNoTerieval() {
      this.selectIds = []
      let flag = false

      if (this.selectArr.length > 0) {
        for (let val of this.selectArr) {
          if (val.isInGroup == 2 || val.isInGroup == 1) {
            flag = true
            this.$message.error('请选择状态为待入组的数据')
            break;
          } else {
            flag = false
          }
        }
        if (!flag) {
          for (let val of this.selectArr) {
            this.visible = true
            this.isShowGroup = 2
            this.selectIds.push(val.id)
          }
        }
      } else {
        this.$message.error('请选择至少选择一条数据')
      }
    },
    update() {
      this.selectArr = []
      this.selectIds = []
      this.selectedRowKeys = []
      this.orConditionStr = ''
      this.nogroupReason = ''
      this.pageNum = 1
      this.page = 1
      this.getSearchData()

    },
    getData() {
      this.isShowGroup = 0;
      this.loading = true;
      this.$get("/patient", {
        pageSize: this.pageSize,
        pageNum: this.page,
        sortOrder: this.sortOrder,
        sortField: this.sortField,
        patientGroupId: this.patientGroupId,
        diseaseType: this.diseaseType,
        findDeptId: this.findDeptId,
        warning: this.warning,
      }).then(res => {
        this.resData = res.data.data;
        this.data = this.resData.rows;
        this.selectedRowKeys = []
        this.loading = false;
      });
    },
    getGroup(code) {
      let data = {}
      if (code == 2) {
        data = {
          isInGroupRemark: this.nogroupReason,
          operationCode: code,
          ids: this.selectIds
        }
      } else {
        data = {
          operationCode: code,
          ids: this.selectIds
        }
      }
      this.$get("/patient/inOrOutGroup", data).then(res => {
        if (res.data.code == 1) {
          this.visible = false
          this.isShowGroup = -1
          this.selectArr = []
          this.selectIds = []
          this.selectedRowKeys = []
          this.orConditionStr = ''
          //  this.isInGroup = ''
          //  this.diseaseType  = ''
          this.nogroupReason = ''
          this.pageNum = 1
          this.page = 1
          this.getSearchData()
        } else {
          this.$message.error(res.data.message)
        }

      }).catch(err => {
      });
    },

    ruzu() {
      let code = 1
      if (this.selectArr.length > 0) {
        if (this.isSelectNum == 3) {
          this.getGroup(1)
        }

      }
      this.visible = false
    },
    noIngroup() {
      if (this.nogroupReason == '' || this.nogroupReason == null) {
        this.$message.error('请输入患者不入组的原因')

      } else {
        let code = 2
        if (this.selectArr.length > 0) {
          this.getGroup(2)
        }
      }

    },
    // 选择组 查询
    handleGroupClick({ key }) {
      if (key == 'default') {
        this.groupTitle = '患者租';
        this.patientGroupId = '';
      } else {
        this.dataGroup.forEach(item => {
          if (item.id == key) {
            this.groupTitle = item.groupName;
            return;
          }
        });
        this.patientGroupId = key;
      }
    },
    //是否入组
    handleMenuClick(e) {
      let len = this.inGroup.data.length - 1
      if (e.key == 'default') {
        this.isInGroup = ''
        this.inGroup.title = '是否入组'

      } else {
        this.isInGroup = this.inGroup.data[e.key].key
        this.inGroup.title = this.inGroup.data[e.key].value
      }
      this.pageNum = 1
      this.page = 1
      this.getSearchData()
    },
    //疾病类型
    handleClick({ key }) {
      if (key == 'default') {
        this.diseaseType = ''
        this.diseaseData.title = '疾病类型'
      } else {
        this.diseaseData.data.forEach(item => {
          if (item.keyId == key) {
            this.diseaseData.title = item.value;
            return;
          }
        });
        this.diseaseType = key;
      }
    },
    ckWarning(e) {
      this.pageNum = 1
      this.page = 1
      this.getSearchData();
    },
    onSearch(value) {
      this.orConditionStr = value
      this.pageNum = 1
      this.page = 1
      this.getSearchData()
    },
    // 删除params里空值
    deleteEmpty(params) {
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (!value || Array.isArray(value) && value.length == 0) {
          delete params[key]
        }
      })
      return params;
    },
    getSearchData() {
      let params = {
        orConditionStr: this.orConditionStr,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        isInGroup: this.isInGroup,
        patientGroupId: this.patientGroupId,
        diseaseType: this.diseaseType,
        findDeptId: this.findDeptId,
        warning: this.warning,
        sortOrder: this.sortOrder,
        sortField: this.sortField,
      }
      params = this.deleteEmpty(params);
      this.loading = true;
      localStorage.setItem('SUFFER_FILTER', JSON.stringify(params));
      if (params.warning) {
        params.warning = 1;
      }
      this.$get("/patient", params).then(res => {
        this.resData = res.data.data;
        this.data = JSON.parse(JSON.stringify(this.resData.rows));
        this.loading = false;
        this.selectedRowKeys = []
        this.selectArr = []
        this.selectIds = []
        this.selectedRowKeys = []
        this.nogroupReason = ''
      });

    },
    pageChange(page, pagesize) {
      this.page = page;
      this.pageSize = pagesize;
      this.page = page
      this.pageNum = page
      this.pageSize = pagesize
      this.getSearchData();
    },
    closeModel() {
      this.visible = false;
    },
    showModal() {
      this.visible = true
    },
    goToDetails(record) {
      if (auth.auth("10105")) {
        this.$router.push({
          path: "/sufferer/detail",
          query: {
            id: record.id
          }
        });
      }

    },
    goMerge() {
      this.$router.push('/sufferer/moreEdit')
    },
    merge(text, record) {
      this.visible = true;
      this.recordMerge = record;
      this.isShowGroup = 5;
    },
    //批量编辑
    goMoreEdit() {
      if (this.selectArr.length > 0) {
        this.visible = true;
        this.isShowGroup = 3
      } else {
        this.$message.error('请选择至少选择一条数据')
      }
    },
    // 患者分组
    goGrouping() {
      if (this.selectArr.length > 0) {
        this.visible = true;
        this.isShowGroup = 6;
      } else {
        this.$message.error('请选择至少选择一条数据')
      }
    },
    exportExcelClick() {
      let params = {
        orConditionStr: this.orConditionStr,
        isInGroup: this.isInGroup,
        patientGroupId: this.patientGroupId,
        diseaseType: this.diseaseType,
        findDeptId: this.findDeptId,
        warning: this.warning,
      }
      params = this.deleteEmpty(params);
      if (params.warning) {
        params.warning = 1;
      }
      this.$export('/patient/down', params, '患者管理列表');
    },
    //单个编辑
    edit($event, record) {
      $event.stopPropagation();
      this.recordList = JSON.parse(JSON.stringify(record))
      this.isShowGroup = 4
      this.visible = true
      // let queryData = {
      //   id:id
      // }
      // this.$router.push({path:'/sufferer/edit',query: queryData})
    },
    handleOk(e) {
      this.visible = false
    },
  }
};
</script>

<style lang="scss" scoped>
.lo-model {
  background: #fff;
}

.lo-model .ant-modal-close {
  display: none;
}

.lo-model .ant-modal {
  width: 100% !important;
}

.lo-model .ant-modal-content {
  box-shadow: none !important;
}

.sample-page {
  width: 100%;
  min-width: 1200px;

  .page-handle {
    height: 60px;
    background: #f8fbfb;
    padding: 0 40px;
    line-height: 60px;
    border-top: 1px solid rgba(240, 242, 245, 1);
    border-bottom: 1px solid rgba(240, 242, 245, 1);

    .right {
      float: right;
      height: 60px;

      .hospital-dropdown-link {
        margin-left: 25px;
      }

      .hospital-dropdown-link {
        color: #3e7ff7;
        font-size: 12px;
      }
    }

    .left {
      height: 60px;
      float: left;

      .ant-btn+.ant-btn {
        margin-left: 5px;
      }
    }
  }

  .page-content {
    padding: 20px 40px;
    background: #fff;

    .table-tr-handle {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(66, 142, 247, 1);

      .handle-btn {
        cursor: pointer;
      }

      .handle-line {
        margin: 0 10px;
      }
    }

    .pagination {
      margin: 20px 0;
      text-align: right;
    }
  }

}

.model-content {
  width: 230px;
  margin: 82px auto 0;
  text-align: left;

  .title {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }

  .model-type {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-top: 72px;

    span {
      display: block;
    }

    span:nth-child(2) {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(164, 164, 164, 1);
    }
  }

  .btn-group {
    margin-top: 25px;

    button {
      width: 100px;
    }

    button:nth-child(2) {

      margin-left: 20px;
    }
  }

}

.no-group {
  .model-content {
    width: 386px;

    textarea {
      margin-top: 52px;
      width: 386px;
      height: 202px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(66, 142, 247, 1)
    }
  }
}
</style>